module.exports = __webpack_public_path__ + "static/media/Loyalty_Star_Icon@3x.50bc8474.png";